var React = require('react');
var ReactNative = require('react-native');

var AppActions = require('./AppActions.js');
var LinkingManager = require('./wrappers/LinkingManager');
var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager');
var FadingView = require('./FadingView');
var FeedPlusView = require('./FeedPlusView');
var FeedPlusSideView = require('./FeedPlusSideView');
var Animated = require('./wrappers/Animated');
var ReUpTabBar = require('./ReUpTabBar');
var GoToAppStoreButton = require('./GoToAppStoreButton');
var ArcMeter = require('./ArcMeter');
var PointsTicker = require('./PointsTicker');
var createReactClass = require('create-react-class');
const Icon = require('./wrappers/ReUpIcon');
var FEED_HEADER_HEIGHT = 80;

var Svg = require('./wrappers/react-native-svg-wrapper');
var {
    Path,
    G,
    Circle
} = Svg;

var Menu = require('./menu.js')
var FeedCard = require('./feedCard.js')
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpField = require('./ReUpField.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpCountdown = require('./ReUpCountdown');
var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');
var MapView = require('./wrappers/react-native-maps-wrapper');
var ReUpButton = require('./ReUpButton');
var Meter = require('./Meter.js');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
} = MK;

var ParallaxScrollView = require('./wrappers/react-native-parallax-scroll-view-wrapper');

var dismissKeyboard = require('react-native-dismiss-keyboard');

var {
  View,
  WebView,
  ScrollView,
  StyleSheet,
  Platform,
  Image,
  TouchableHighlight,
  Dimensions,
  TouchableWithoutFeedback
} = ReactNative;


function findGetParameter(parameterName)
{
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item)
    {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });

  return result;
}

var ProHome = createReactClass(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    var maxWidth = 400;
    var maxHeight = 700;
    var width = Math.min(this.props.initialLayout.width-24, maxWidth);
    var height = Math.min(this.props.initialLayout.height-24, maxHeight);
    // var ratio = parseFloat(750 / 1334);
    // width = Math.min(width, height*ratio);
    // height = Math.min(height, width/ratio);
    var horizontalMargin = (this.props.initialLayout.width - width)/2;
    var verticalMargin = (this.props.initialLayout.height - height)/2;

    var userID = findGetParameter("userid");
    if( userID == null ) userID = -1;
    var hash = findGetParameter("hash");
    if( hash == null ) hash = "";

    return {
      horizontalMargin,
      verticalMargin,
      rotationFront: new Animated.Value(90),
      rotationBack: new Animated.Value(90),

      isShowingFront: true,

      isShowingHome: false,
      isShowingError: false,

      userIsInURL:false,

      isInError:false,
      errorMessage:"",

      appStoreURL:"",
      playStoreURL:"",

      backFeatureData:this.props.appManager.getFeatureForName("SimpleSettings"),
    }
  },

  _context: 0,
  componentDidMount : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();
    var userID = findGetParameter("userid");
    if( userID == null ) userID = -1;
    var hash = findGetParameter("hash");
    if( hash == null ) hash = "";

    if( userID != null && hash != null )
    {
      NetworkManager.getUser(appManager, userID, hash, (urlUser)=>
      {
        urlUser[ModelConstants.Password] = hash;
        appManager.setCurrentUser(urlUser, ()=>
        {

        });
        NetworkManager.update(appManager, ["Campaigns"], (data)=>
        {
          thisThing.setState({isShowingHome:true})

          var signupCampaign = null;
          for( var i = 0; i < data.Campaigns.length; i++ )
          {
            var campaign = data.Campaigns[i];
            if( campaign.Type == "Signup" ) signupCampaign = JSON.parse(campaign.CampaignBlob);
          }
          thisThing.setState({
            signupPoints:signupCampaign == null ? null : signupCampaign.Points,
            userIsInURL:true,
            appStoreURL:urlUser.AppStoreURL,
            playStoreURL:urlUser.PlayStoreURL,
          });

          thisThing.showFront();
        }, (data)=>
        {
          thisThing.setState({isShowingHome:true,
            appStoreURL:data.AppStoreURL,
            playStoreURL:data.PlayStoreURL})
          thisThing.showFront();
        }, ()=>
        {
          thisThing.setState({isShowingHome:true})
          thisThing.showFront();
        })
      }, (data)=>
      {
        thisThing.setState({
          isShowingHome:true,
          appStoreURL:data.AppStoreURL,
          playStoreURL:data.PlayStoreURL});
        thisThing.showFront();
      }, ()=>
      {
        thisThing.setState({isShowingError:true, errorTitle:"Connection Issue", errorBody:locManager.localizedStringForKey("NO_CONNECTION_STATEMENT")});
        thisThing.showFront();
      })
    }
    else if( appManager._isDemo )
    {
      NetworkManager.getUser(appManager, 'kjregan10@gmail.com', 'asdfwxyzabcd', (urlUser)=>
      {
        hash = urlUser[ModelConstants.Hash];
        urlUser[ModelConstants.Password] = hash;
        appManager.setCurrentUser(urlUser, ()=>
        {

        });
        NetworkManager.update(appManager, ["Campaigns"], (data)=>
        {
          thisThing.setState({isShowingHome:true})

          var signupCampaign = null;
          for( var i = 0; i < data.Campaigns.length; i++ )
          {
            var campaign = data.Campaigns[i];
            if( campaign.Type == "Signup" ) signupCampaign = JSON.parse(campaign.CampaignBlob);
          }
          thisThing.setState({
            signupPoints:signupCampaign == null ? null : signupCampaign.Points,
            userIsInURL:true,
            appStoreURL:urlUser.AppStoreURL,
            playStoreURL:urlUser.PlayStoreURL,
          });

          thisThing.showFront();
        }, (data)=>
        {
          thisThing.setState({isShowingHome:true,
            appStoreURL:data.AppStoreURL,
            playStoreURL:data.PlayStoreURL})
          thisThing.showFront();
        }, ()=>
        {
          thisThing.setState({isShowingHome:true})
          thisThing.showFront();
        })
      }, (data)=>
      {
        thisThing.setState({
          isShowingHome:true,
          appStoreURL:data.AppStoreURL,
          playStoreURL:data.PlayStoreURL});
        thisThing.showFront();
      }, ()=>
      {
        thisThing.setState({isShowingError:true, errorTitle:"Connection Issue", errorBody:locManager.localizedStringForKey("NO_CONNECTION_STATEMENT")});
        thisThing.showFront();
      })
    }
    else
    {
      thisThing.setState({isShowingHome:true})
      this.showFront();
    }
  },

  componentWillUnmount : function()
  {
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.initialLayout !== 'undefined' )
    {
      var maxWidth = 400;
      var maxHeight = 700;
      var width = Math.min(newProps.initialLayout.width-24, maxWidth);
      var height = Math.min(newProps.initialLayout.height-24, maxHeight);
      // var ratio = parseFloat(750 / 1234);
      // width = Math.min(width, height*ratio);
      // height = Math.min(height, width/ratio);
      var horizontalMargin = (newProps.initialLayout.width - width)/2;
      var verticalMargin = (newProps.initialLayout.height - height)/2;

      this.setState({horizontalMargin, verticalMargin});
    }
  },

  _showingFront : false,
  showFront : function()
  {
    if( this._showingFront ) return;
    this._showingFront = true;

    var thisThing = this;
    Animated.timing(
      thisThing.state.rotationBack,
      {
        toValue: 90,
        duration: 200
      }
    ).start(function()
    {
      thisThing.setState({isShowingFront:true});
      Animated.timing(
        thisThing.state.rotationFront,
        {
          toValue: 0,
          duration: 200
        }
      ).start(function()
      {

      });
    });
  },

  showBack : function()
  {
    if( !this._showingFront ) return;
    this._showingFront = false;

    var thisThing = this;
    Animated.timing(
      thisThing.state.rotationFront,
      {
        toValue: 90,
        duration: 200
      }
    ).start(function()
    {
      thisThing.setState({isShowingFront:false});
      Animated.timing(
        thisThing.state.rotationBack,
        {
          toValue: 0,
          duration: 200
        }
      ).start(function()
      {

      });
    });
  },

  checkUserChanged : function()
  {
  },

  didUpdate : function(data)
  {

  },

  showTerms: function()
  {
    var tosLink = this.props.appManager.getTermsLink();
    LinkingManager.openURL(tosLink)
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();

    var bgImage = this.props.appManager.absoluteResourceForPath("Feed" + '/' + this.props.featureData.bgImage);

    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");
    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor",.6);
    var circleIconColor = appManager.getColorForKey("ProfileImageColor");

    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");

    var stripHeight = 120;

    var signupInstruction = locManager.localizedStringForKey("SIGN_UP_INSTRUCTION")
    if( this.state.signupPoints != null )
    {
      signupInstruction = locManager.localizedStringForKeyAndParams("SIGN_UP_INSTRUCTION_BONUS", [locManager.localizedPoints(this.state.signupPoints)]);
    }

    var addedBackStyle = {};
    if( Platform.OS == 'web' ) addedBackStyle.height = "calc(100% - 60px)";

    return <View style={[styles.container, {backgroundColor:generalColor, height:this.props.initialLayout.height, width:this.props.initialLayout.width}]}>
      <BlurView ref={(c) => { this._ref_blurView = c; }} blurType="light" initialOpacity={0} style={{position:'absolute', left:0, right:0, top:0, bottom:0}} imageName={bgImage} imageKey={appManager.getImageKey("bg")} />
      <Animated.View style={
      {
        display:this.state.isShowingFront ? 'block' : 'none',
        transform: [{ rotateY: this.state.rotationFront}],
        flexDirection:'column', alignSelf:'stretch', flex:1, marginLeft:this.state.horizontalMargin, marginRight:this.state.horizontalMargin, marginTop:this.state.verticalMargin, marginBottom:this.state.verticalMargin, borderRadius:20, backgroundColor:generalColor,
        overflow:'hidden'
      }}>
      {
        this.state.isShowingError ?
          <View style={{flex:1, flexDirection:'column', alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
            <ReUpText appManager={appManager} isTitle={true} style={{color:profileTitleColor, textAlign:'center', margin:10}}>
            {this.state.errorTitle}
            </ReUpText>
            <ReUpText appManager={appManager} style={{color:profileTitleColor, textAlign:'center', margin:10}}>
            {this.state.errorBody}
            </ReUpText>
          </View>
        : null
      }
      {
        this.state.isShowingHome ?
          <View key="feedPlusView" ref={(a)=>{if( a != null ) thisThing._feedPlusView = a}}
            style={{backgroundColor:profileColor, flexDirection:'column', flex:1, alignSelf:'stretch', height:this.props.initialLayout.height-(2*this.state.verticalMargin)}}>
            <View style={{height:30}}>
            </View>
            <View style={{height:stripHeight, backgroundColor:profileImageColor}}>
              <Image style={{width:'100%', height:stripHeight}} resizeMode={"cover"} source={{uri: stripImage}} />
              <View style={{position:'absolute', top:20, left:20, right:20, bottom:20}}>
                <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
              </View>
            </View>
            <View style={{flex:1}} />
            {
              this.state.userIsInURL ?
                <View style={{padding:20, flexDirection:'column', alignItems:'center'}}>
                  <ReUpText appManager={appManager} isTitle={true} style={{color:profileTitleColor, textAlign:'center', marginBottom:4}}>
                  {locManager.localizedStringForKey("YOU_ARE_VERIFIED_STATEMENT")}
                  </ReUpText>
                  <ReUpText appManager={appManager} style={{color:profileTitleColor, marginTop:20, marginBottom:20, textAlign:'center'}}>
                  {signupInstruction}
                  </ReUpText>
                </View>
              :
                <View style={{flexDirection:'column', alignItems:'center'}}>
                  <ReUpText appManager={appManager} isTitle={true} style={{color:profileTitleColor, textAlign:'center', marginBottom:4}}>
                  {signupInstruction}
                  </ReUpText>
                </View>
            }
            <View style={{flex:1}} />
            <View style={{flexDirection:'column', alignItems:'center'}}>
              <GoToAppStoreButton appManager={appManager} appStoreURL={this.state.appStoreURL} playStoreURL={this.state.playStoreURL} style={{margin:10, width:140, height:44}} />
            </View>
            <View style={{flex:1, flexDirection:'column', alignSelf:'stretch', alignItems:'center', justifyContent:'flex-end'}}>
              <ReUpButton isTertiary={true} appManager={appManager} text={locManager.localizedStringForKey("TERMS_AND_PREFERENCES_BUTTON")}
                onPress={()=>{thisThing.showBack()}} />
              <View style={{height:20}} />
            </View>
          </View>
        : null
      }
      </Animated.View>
      <Animated.View style={
        {
          display:this.state.isShowingFront ? 'none' : 'block',
          flexDirection:'column',
          transform: [{ rotateY: this.state.rotationBack}],
          alignSelf:'stretch', flex:1, marginLeft:this.state.horizontalMargin, marginRight:this.state.horizontalMargin, marginTop:this.state.verticalMargin, marginBottom:this.state.verticalMargin, borderRadius:20, backgroundColor:headerColor,
          alignItems:'stretch',
          overflow:'hidden'
        }}>
        <View style={{height:60, flexDirection:'row', alignItems:'stretch', justifyContent:'center'}}>
          <View style={{width:60, justifyContent:'center', alignItems:'center'}}>
            <ReUpIconButton appManager={appManager} iconName={"angle-left"} onPress={()=>this.showFront()} type={2} />
          </View>
          <View style={{flex:1, justifyContent:'center', alignItems:'center'}}>
            <ReUpText appManager={appManager} isTitle={true} style={{color:headerTitleColor, textAlign:'center'}}>
            {this.state.backFeatureData.data.title}
            </ReUpText>
          </View>
          <View style={{width:60}}>
          </View>
        </View>
        <View style={[{flex:1}, addedBackStyle]}>
        {appManager.isLoggedIn() ? this.props.featureBuilder.featureForData(this.state.backFeatureData, {width:this.props.initialLayout.width - 2*this.state.horizontalMargin, height:this.props.initialLayout.height-60-(2*this.state.verticalMargin)}, this.props.appManager) : null}
        </View>
      </Animated.View>
    </View>;
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
    backgroundColor:'red'
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  feedHeader: {
    height:FEED_HEADER_HEIGHT,
    flexDirection:'row'
  },
  feedHeaderLeftContainer: {
    padding:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    alignItems:'center',
    justifyContent:'center',
  },
  profileImage: {
    height:FEED_HEADER_HEIGHT - 16,
    width:FEED_HEADER_HEIGHT - 16,
    borderRadius:(FEED_HEADER_HEIGHT - 16)/2,
    borderWidth:2,
    borderColor:'black',
    justifyContent:'center',
  },
  profileImageText: {
    textAlign:'center',
    fontSize:(FEED_HEADER_HEIGHT - 20)/2,
    fontWeight:'bold',
    backgroundColor:'transparent'
  },
  feedHeaderCenterContainer: {
    height:FEED_HEADER_HEIGHT,
    paddingVertical:10,
    flex:1,
    justifyContent:'space-between',
  },

  feedHeaderRightContainer: {
    paddingVertical:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    justifyContent:'space-between',
    alignItems:'center',
  },
  feedHeaderInfo: {
    fontWeight:'bold'
  },
})
ProHome.dataDependencies = [];

module.exports = ProHome;
